/* eslint-disable no-nested-ternary */
/* eslint-disable import/named */
import React, { useState } from "react";
import moment from "moment";
import { bool, shape, string } from "prop-types";
import * as i18nUtils from "util/i18n";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedDate from "pages/_components/FormattedDate";

import FormattedAmount from "pages/_components/FormattedAmount";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import InfoTag from "pages/echeck/components/InfoTag";
import CustomData from "pages/_components/CustomData/CustomData";
import MainContainer from "pages/_components/MainContainer";
import Drawer from "pages/_components/Drawer/Drawer";
import VepDetail from "pages/afipPaymentLink/components/VepDetail";

const VepsHistoricItem = ({ vep, isDesktop, isReviewPage, type }) => {
    const [openSidebarDetail, setOpenSidebarDetail] = useState(false);

    const handleDetail = () => {
        setOpenSidebarDetail(true);
    };
    const onClose = () => {
        setOpenSidebarDetail(false);
    };

    const options = [
        {
            text: "vep.payment.action.detail",
            textType: "I18N",
            func: () => handleDetail(),
        },
        // {
        //     text: "vep.payment.action.delete",
        //     textType: "I18N",
        //     func: () => {},
        // },
    ];

    return (
        <>
            <GridTable.Data
                className="align-items-center"
                columnStart={isDesktop ? 1 : 1}
                rowStart={isDesktop ? 1 : 1}
                alignX={isDesktop ? "center" : "flex-start"}>
                {isDesktop ? (
                    <CustomText className="ellipsis-vep" text={vep.id} textType="TEXT" />
                ) : (
                    <CustomData
                        titleText="vep.payment.number"
                        titleTextType="I18N"
                        valueText={vep.id}
                        valueTextType="TEXT"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                className="align-items-center"
                columnStart={isDesktop ? 2 : 1}
                rowStart={isDesktop ? 1 : 2}
                alignX={isDesktop ? "center" : "flex-start"}>
                {!isReviewPage && vep.paymentDateTime ? (
                    <CustomData
                        titleText="vep.payment.date"
                        titleTextType="I18N"
                        valueText={moment(vep.paymentDateTime.split(" ")[0], "YYMMDD").format("DD/MM/YYYY")}
                        valueTextType="TEXT"
                    />
                ) : isDesktop ? (
                    <FormattedDate date={vep.expirationDate} dateFormat="DD/MM/YYYY" />
                ) : (
                    <CustomData
                        titleText="vep.payment.dueDate"
                        titleTextType="I18N"
                        valueText={vep.expirationDate}
                        valueTextType="DATE"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                className="align-items-center"
                columnStart={isDesktop ? 3 : 1}
                rowStart={isDesktop ? 1 : 3}
                alignX={isDesktop ? "center" : "start"}>
                {isDesktop ? (
                    <CustomText text={vep.cuitOrigin} textType="TEXT" />
                ) : (
                    <CustomData
                        titleText="vep.payment.cuitCreator"
                        titleTextType="I18N"
                        valueText={vep.cuitOrigin}
                        valueTextType="TEXT"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                className="align-items-center"
                columnStart={isDesktop ? 4 : 1}
                rowStart={isDesktop ? 1 : 4}
                alignX={isDesktop ? "center" : "start"}>
                {isDesktop ? (
                    <CustomText text={vep.cuitTaxpayer} textType="TEXT" />
                ) : (
                    <CustomData
                        titleText="vep.payment.cuitTaxpayer"
                        titleTextType="I18N"
                        valueText={vep.cuitTaxpayer}
                        valueTextType="TEXT"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                className="align-items-center"
                columnStart={isDesktop ? 5 : 1}
                rowStart={isDesktop ? 1 : 5}
                alignX={isDesktop ? "center" : "start"}>
                {isDesktop ? (
                    <CustomText text={vep.description} textType="TEXT" />
                ) : (
                    <CustomData
                        titleText="vep.payment.description"
                        titleTextType="I18N"
                        valueText={vep.description}
                        valueTextType="TEXT"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                className="align-items-center vep-amount"
                columnStart={isDesktop ? 6 : 1}
                rowStart={isDesktop ? 1 : 6}
                alignX={isDesktop ? "center" : "start"}>
                {isDesktop ? (
                    <FormattedAmount currency={vep.currency} quantity={vep.amount} />
                ) : (
                    <CustomData
                        titleText="vep.payment.amount"
                        titleTextType="I18N"
                        valueText={<FormattedAmount currency={vep.currency} quantity={vep.amount} />}
                        valueTextType="TEXT"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                className="tags-wrapper align-items-center ellipsis-vep"
                columnStart={isDesktop ? 7 : 2}
                rowStart={1}
                alignX={isDesktop ? "center" : "end"}>
                {!isReviewPage ? (
                    <InfoTag
                        type="info"
                        message={i18nUtils.get("vep.payment.status.PAGADO", "Pagado")}
                        tagBackground="success"
                    />
                ) : (
                    <InfoTag
                        type="info"
                        message={i18nUtils.get("vep.payment.status.PENDIENTE_PAGO", "Pendiente")}
                        tagBackground="warning"
                    />
                )}
            </GridTable.Data>
            <MainContainer className="vep">
                <Drawer
                    openSidebar={openSidebarDetail}
                    onClose={onClose}
                    isFullHeight={!isDesktop}
                    enableCloseButton={!!isDesktop}>
                    <VepDetail
                        isReviewPage={isReviewPage}
                        isHistoric
                        vep={vep}
                        isDesktop={isDesktop}
                        handleClose={onClose}
                        openForm={openSidebarDetail}
                        type={type}
                    />
                </Drawer>
            </MainContainer>
            {!isReviewPage && (
                <GridTable.Data columnStart={isDesktop ? 8 : 3} rowStart={1} rowWidth={1} alignX="end">
                    <CustomButton pullRight icon="images/figma/icon/menu-mobile.svg" options={options} />
                </GridTable.Data>
            )}
        </>
    );
};

VepsHistoricItem.propTypes = {
    vep: shape({}).isRequired,
    isDesktop: bool.isRequired,
    isReviewPage: bool,
    type: string,
};

VepsHistoricItem.defaultProps = {
    isReviewPage: false,
    type: null,
};

export default VepsHistoricItem;
